import React, {FC, useState} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';

export const ButtonTabs: FC<{
  dataTestId?: string;
  children: React.ReactElement<{label?: string}>[];
}> = ({dataTestId = 'tabs', children}) => {
  const [selectedTabId, setSelectedTabId] = useState(0);
  if (!children) {
    return null;
  }

  return (
    <div>
      <Wrapper data-testid={dataTestId}>
        {children.map((child, index) => {
          return (
            <Selector
              key={index}
              onClick={() => setSelectedTabId(index)}
              active={selectedTabId === index}
              first={index === 0}
              flex={1 / (children.length ?? 1)}
              last={index === children.length - 1}
            >
              {child.props.label}
            </Selector>
          );
        })}
      </Wrapper>
      <div>{children[selectedTabId]}</div>
    </div>
  );
};

const BORDER_RADIUS = '3px';

const Wrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  height: 2rem;
  width: 100%;
  border-radius: ${BORDER_RADIUS};
  border: 1px solid ${COLORS.Grey3};
`;

const Selector = styled.button<{
  active?: boolean;
  first: boolean;
  flex: number;
  last: boolean;
}>`
  align-items: center;
  background-color: ${({active}) => (active ? COLORS.Black : 'transparent')};
  color: ${({active}) => (active ? COLORS.White : COLORS.Black)};
  border: none;
  border-radius: ${BORDER_RADIUS};
  display: flex;
  flex: ${({flex}) => flex};
  font-size: inherit;
  font-weight: inherit;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  transition: 0.15s;

  &:focus {
    outline: none;
  }
`;
